import formName from 'constants/formName'
import { actions, actionTypes, selectors } from 'data'
import { SetResetCodeActionType } from 'data/actions'
import { notifyError, notifySuccess } from 'data/App/sagas'
import { ForgotPasswordFormType } from 'data/types'
import isNil from 'lodash/isNil'
import { call, fork, put, select, take, takeEvery } from 'redux-saga/effects'
import { resetPassword, sendResetPasswordEmail } from 'services/api/auth'
import { Response } from 'utils/fetchApi'

const submitForm = function* () {
  yield put(actions.form.change(formName.FORGOT_PASSWORD, 'loading', true))

  const form: ForgotPasswordFormType = yield select(selectors.forgotPassword.getValues)

  if (!isNil(form.email)) {
    const data: Response<void> = yield call(sendResetPasswordEmail, form)

    yield put(actions.form.change(formName.FORGOT_PASSWORD, 'loading', false))

    if (!data.ok) {
      yield call(notifyError, data.error.cause, 'KO_GENERIC')
      return
    }

    yield put(actions.form.change(formName.FORGOT_PASSWORD, 'emailSent', true))
  }
}

const resetPasswordSaga = function* () {
  while (true) {
    const action: SetResetCodeActionType = yield take(actionTypes.forgotPassword.SET_RESET_CODE)
    yield put(actions.app.showModal('RESET_PASSWORD'))
    yield take(actionTypes.forgotPassword.SUBMIT_RESET)

    const form: ForgotPasswordFormType = yield select(selectors.forgotPassword.getValues)

    yield put(actions.form.change(formName.FORGOT_PASSWORD, 'loading', true))

    const data: Response<void> = yield call(resetPassword, {
      ...form,
      resetCode: action.payload.code
    })

    yield put(actions.form.change(formName.FORGOT_PASSWORD, 'loading', false))

    if (!data.ok) {
      yield call(notifyError, data.error.cause, 'KO_GENERIC')
    } else {
      yield call(notifySuccess, 'OK_RESET_PASSWORD')
      yield put(actions.app.hideModal('RESET_PASSWORD'))
    }
  }
}

export default function* forgotPasswordForm() {
  yield fork(resetPasswordSaga)

  yield takeEvery(actionTypes.forgotPassword.SUBMIT, submitForm)
}
